import { render } from "./GetStartedPage.vue?vue&type=template&id=4fab7727&scoped=true"
import script from "./GetStartedPage.vue?vue&type=script&lang=js"
export * from "./GetStartedPage.vue?vue&type=script&lang=js"

import "./GetStartedPage.vue?vue&type=style&index=0&id=4fab7727&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fab7727"]])

export default __exports__